export default __webpack_public_path__ + "static/media/achievement2-1.c38453e4.png";